<template>
  <router-view />
</template>
<script>
export default {
  name: "Usuarios",
};
</script>

<style scoped></style>
